let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4koAN")).then(() => parcelRequire('dZZnc'));